import { MouseEventHandler, useRef } from 'react';
import { CText } from './CText';

export const NodeArtifactsConstant = {
  width: 230,
  height: 80,
};

export function NodeArtifacts(props: {
  artifact: string;
  name: string;
  tags: string[];
  focus: boolean;
  onClick: (e: React.MouseEvent<HTMLDivElement>) => void;
  artifactImg?: string;
  'data-testid'?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);
  let color = '#fff';
  if (props.artifact === 'Trend') color = '#70E77B';
  else if (props.artifact === 'Persona') color = '#FF62AF';
  else if (props.artifact === 'Brief') color = '#52A5FF';
  else if (props.artifact === 'Insight') color = '#FF756B';
  else if (props.artifact === 'Benchmark') color = '#FFE65A';
  else if (props.artifact === 'Design Principle') color = '#D685FF';
  else color = '#B5B5B9';

  return (
    <div
      ref={ref}
      data-testid={props['data-testid']}
      className={`relative rounded-[10px] bg-[#FDFBFB] dark:bg-[#1A1A1A] border-1 flex justify-between hover:border-white
      ${
        props.focus ? 'border-[#404040] dark:border-white' : 'border-[#EEEEEE] dark:border-white/30'
      }
  `}
      style={{
        width: NodeArtifactsConstant.width,
        // height: NodeArtifactsConstant.height,
      }}
      onClick={(e: React.MouseEvent<HTMLDivElement>) => {
        props.onClick(e);
      }}
    >
      <div className="flex flex-1 items-center justify-between">
        {/* {props.artifactImg && (
            <img src={props.artifactImg} className="w-[35px] h-[35px] rounded-full" />
          )} */}
        <div className="flex flex-col justify-center gap-[8px] p-[12px]">
          <div className="w-full flex items-center justify-start">
            <CText type="body3" color={color}>
              ● {props.artifact}
            </CText>
          </div>
          <CText type="H2">{props.name}</CText>
          {props.tags.length > 0 && (
            <div className="w-full flex flex-start justify-start gap-[3px] flex-wrap">
              {props.tags.map((tag, i) => (
                <div
                  className="h-[16px] px-[12px] rounded-[12.3px] border-[0.5px] border-solid 
                  border-[#5F6A80] flex items-center justify-center"
                  key={i}
                >
                  <CText type="body3" opacity={0.6}>
                    {tag}
                  </CText>
                </div>
              ))}
            </div>
          )}
        </div>
        {props.artifactImg && (
          <div className="shrink-0 w-[57px] h-full rounded-r-[9px] overflow-hidden">
            <img src={props.artifactImg} className="w-full h-full object-cover" />
          </div>
        )}
      </div>
    </div>
  );
}
